import { render } from "./Shell.vue?vue&type=template&id=c4196da2&ts=true"
import script from "./Shell.vue?vue&type=script&lang=ts"
export * from "./Shell.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__